/**
 * Quote Process Handlers
 * Public read for landing page (active quotes only)
 */

import { handleRequest } from './config'
import { ApiResponse } from '../types'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'
import type { Quote } from '../../../../pure-js/types/Quote'
import type { GetQuotesRequest, GetQuotesResponse } from '../types/quotes'

/**
 * Get quotes
 * Optionally filter by activeOnly (for landing page: activeOnly: true)
 */
export const getQuotes = async (request: GetQuotesRequest = {}): Promise<ApiResponse<Quote[]>> => {
  return handleRequest(
    () => Promise.resolve({ data: [], success: true } as ApiResponse<Quote[]>),
    async () => {
      try {
        const callable = httpsCallable<GetQuotesRequest, GetQuotesResponse>(functions, 'getQuotes')
        const result = await callable(request)

        if (!result.data.success) {
          const errorMessage = result.data.error || 'Failed to fetch quotes from backend'
          throw new Error(errorMessage)
        }

        if (!result.data.quotes) {
          return { data: [], success: true }
        }

        return {
          data: result.data.quotes,
          success: true
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw error
        }
        throw new Error('Unknown error occurred while fetching quotes')
      }
    }
  )
}
